import { TranslationSet } from './en';

// TODO: translate values from English
export const pt: TranslationSet = {
  '(From Now)': '(A partir de agora)',
  '(From Scheduled)': '(Do agendado)',
  '{amount} Off. Expires: {expires}.': '{amount} Desativado. Expira em: {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'Um relatório detalhado mostrando cada atividade e quanto tempo um técnico ou membro da equipe demorou entre e em cada local com o tempo total no local.',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'Um tipo de serviço com inspeção habilitada aparecerá na lista "para inspecionar" no celular. Também é usado em relatórios.',
  'Accept Invite': 'Aceitar convite',
  'Add Condition': 'Adicionar condição',
  'Add deficiencies to the equipment type': 'Adicione deficiências ao tipo de equipamento',
  'Add Deficiency': 'Adicionar deficiência',
  'Add Equipment Field': 'Adicionar campo de equipamento',
  'Add Equipment Type': 'Adicionar tipo de equipamento',
  'Add Equipment': 'Adicionar equipamento',
  'Add Floor Plan': 'Adicionar planta baixa',
  'Add history by clicking the plus in the top right or by performing a service.': 'Adicione histórico clicando no sinal de adição no canto superior direito ou realizando um serviço.',
  'Add History': 'Adicionar histórico',
  'Add Model Field': 'Adicionar campo de modelo',
  'Add Model': 'Adicionar modelo',
  'Add Option': 'Adicionar opção',
  'Add Question': 'Adicionar pergunta',
  'Add questions using the plus icon in the top right': 'Adicione perguntas usando o ícone de adição no canto superior direito',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'Adicione categorias de meses de serviço em configurações > categorias de meses de serviço. Os meses de serviço permitem manter diferentes tipos de equipamentos em meses selecionados para cada local. Exemplo: Alarmes em Maio e Outubro e Extintores em Dezembro.',
  'Add Service Month Category': 'Adicionar categoria de mês de serviço',
  'Add Service Type': 'Adicionar tipo de serviço',
  'Add service types in the settings': 'Adicione tipos de serviço nas configurações',
  'Add service types using the plus icon in the top right': 'Adicione tipos de serviço usando o ícone de adição no canto superior direito',
  'Add services to the equipment type': 'Adicione serviços ao tipo de equipamento',
  'Add site Field': 'Adicionar campo do site',
  'Add Site Override': 'Adicionar substituição de site',
  'Add Site Type': 'Adicionar tipo de site',
  'Add Site': 'Adicionar site',
  'Add Sites': 'Adicionar sites',
  'Add User': 'Adicionar usuário',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'Adicione seus próprios campos em Configurações > Campos personalizados > Campos do site',
  'Add': 'Adicionar',
  'Adding': 'Adicionando',
  'Address': 'Endereço',
  'Advance from Now': 'Avance a partir de agora',
  'Advance from Scheduled': 'Avançar do programado',
  'Agree': 'Concordo',
  'All Sites Scheduled!': 'Todos os sites agendados!',
  'All': 'Todos',
  'Already have an account? Login': 'Já tem uma conta? Entrar',
  'An error happened while syncing': 'Ocorreu um erro durante a sincronização',
  'April': 'abril',
  'August': 'Agosto',
  'Back': 'Voltar',
  'Billing Portal': 'Portal de cobrança',
  'Building Reports': 'Construindo Relatórios',
  'Cancel Plan': 'Cancelar plano',
  'Cancel Subscription': 'Cancelar assinatura',
  'Cancel': 'Cancelar',
  'Change Model Fields': 'Alterar campos do modelo',
  'Change Password': 'Alterar senha',
  'Checklist Information': 'Informações da lista de verificação',
  'Checklist Question': 'Pergunta da lista de verificação',
  'Checklist': 'Lista de verificação',
  'Choose File': 'Escolha arquivo',
  'City': 'Cidade',
  'Clear All Data': 'Limpar todos os dados',
  'Clear': 'Limpar',
  'Click or tap to add location': 'Clique ou toque para adicionar localização',
  'Close': 'Fechar',
  'Company-Wide Reports': 'Relatórios para toda a empresa',
  'Conditions': 'Condições',
  'Contact': 'Contato',
  'Copy Barcode': 'Copiar código de barras',
  'Could not access': 'Não foi possível acessar',
  'Could not find equipment with the scanned barcode': 'Não foi possível encontrar o equipamento com o código de barras lido',
  'Could Not Service': 'Não foi possível atender',
  'Create': 'Criar',
  'Creating Your Account': 'Criando sua conta',
  'Credentials are not valid': 'As credenciais não são válidas',
  'CSV': 'CSV',
  'Custom Equipment Fields': 'Campos de equipamentos personalizados',
  'Custom Fields': 'Campos personalizados',
  'Custom Model Fields': 'Campos de modelo personalizado',
  'Custom site Fields': 'Campos personalizados do site',
  'Date': 'Data',
  'Debug': 'Depurar',
  'December': 'Dezembro',
  'Deficiencies': 'Deficiências',
  'Deficiency Report': 'Relatório de deficiência',
  'Deficiency': 'Deficiência',
  'Delete Equipment Field?': 'Excluir campo de equipamento?',
  'Delete Equipment Type?': 'Excluir tipo de equipamento?',
  'Delete Equipment Type': 'Excluir tipo de equipamento',
  'Delete Equipment?': 'Excluir equipamento?',
  'Delete Equipment': 'Excluir equipamento',
  'Delete Floor Plan?': 'Excluir planta baixa?',
  'Delete Model Field?': 'Excluir campo do modelo?',
  'Delete Model?': 'Excluir modelo?',
  'Delete Model': 'Excluir modelo',
  'Delete Override': 'Excluir substituição',
  'Delete Question?': 'Excluir pergunta?',
  'Delete Question': 'Excluir pergunta',
  'Delete Record?': 'Excluir registro?',
  'Delete Service Month?': 'Excluir mês de serviço?',
  'Delete Service Type?': 'Excluir tipo de serviço?',
  'Delete Site Field?': 'Excluir campo do site?',
  'Delete Site Type?': 'Excluir tipo de site?',
  'Delete Site?': 'Excluir site?',
  'Delete Site': 'Excluir site',
  'Delete User?': 'Excluir usuário?',
  'Delete User': 'Excluir usuário',
  'Delete': 'Excluir',
  'Deleted Equipment Field': 'Campo de equipamento excluído',
  'Deleted Equipment': 'Equipamento excluído',
  'Deleted Floor Plan': 'Planta baixa excluída',
  'Deleted Model Field': 'Campo de modelo excluído',
  'Deleted Record': 'Registro excluído',
  'Deleted Service Month': 'Mês de serviço excluído',
  'Deleted Service Type': 'Tipo de serviço excluído',
  'Deleted Site Field': 'Campo de site excluído',
  'Deleted Site Type': 'Tipo de site excluído',
  'Detailed': 'Detalhado',
  'Did not want done': 'Não queria fazer',
  'Done by others': 'Feito por outros',
  'Don\'t have an account? Sign Up': 'Não tem uma conta? Inscreva-se',
  'Done': 'Concluído',
  'Edit Dates': 'Editar datas',
  'Edit Equipment': 'Editar equipamento',
  'Edit': 'Editar',
  'Email is not valid': 'E-mail não é válido',
  'End Date': 'Data de término',
  'Enter your email address': 'Digite seu endereço de e-mail',
  'Equipment already has this barcode': 'Equipamento já possui esse código de barras',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'O equipamento pode ser qualquer coisa, desde um extintor de incêndio até uma esteira. Configure os tipos de equipamento em configurações> tipos de equipamento.s',
  'Equipment Deleted': 'Equipamento excluído',
  'Equipment Due Consolidated Report': 'Relatório Consolidado de Vencimentos de Equipamentos',
  'Equipment Due Report': 'Relatório de Vencimento de Equipamento',
  'Equipment Field Information': 'Informações de campo do equipamento',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'Os campos de equipamento permitem adicionar diferentes campos adicionais ao tipo de equipamento, como "Tensão" ou "Km".',
  'Equipment Fields': 'Campos de Equipamentos',
  'Equipment for a site with all scheduled services.': 'Equipamento para um local com todos os serviços agendados.',
  'Equipment Options': 'Opções de equipamento',
  'Equipment Report': 'Relatório de Equipamento',
  'Equipment Service Report': 'Relatório de serviço de equipamento',
  'Equipment SKU': 'SKU do equipamento',
  'Equipment Type Deleted': 'Tipo de equipamento excluído',
  'Equipment Type': 'Tipo de equipamento',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'Os tipos de equipamento adicionam rapidamente definições de inspeção e serviço ao equipamento quando um modelo que os contém é selecionado. Exemplos: extintor de incêndio, esteira, caminhão',
  'Equipment Types': 'Tipos de equipamentos',
  'Equipment': 'Equipamento',
  'Export Billing Data': 'Exportar dados de faturamento',
  'Export Data': 'Exportar dados',
  'Export': 'Exportar',
  'Failed to load organization.': 'Falha ao carregar a organização.',
  'Failed to save the organization.': 'Falha ao salvar a organização.',
  'February': 'Fevereiro',
  'Fill out the options below to prepare your report.': 'Preencha as opções abaixo para preparar seu relatório.',
  'Filter By': 'Filtrar por',
  'FlameTask Basic Subscription': 'Assinatura básica FlameTask',
  'FlameTask Enterprise Subscription': 'Assinatura Empresarial FlameTask',
  'FlameTask Pro Subscription': 'Assinatura FlameTask Pro',
  'Floor Plan Location': 'Localização da planta baixa',
  'Floor Plan': 'Planta baixa',
  'Floor Plans': 'Plantas baixas',
  'Force Error': 'Forçar erro',
  'Forgot Password': 'Esqueci a senha',
  'Generate': 'Gerar',
  'Hide "added" history records': 'Ocultar registros históricos "adicionados"',
  'Hide Advanced': 'Ocultar avançado',
  'History': 'História',
  'How long a user spent at a site with time between actions.': 'Quanto tempo um usuário passou em um site com tempo entre as ações.',
  'If this email matched an account, a link was sent to reset your password.': 'Se este e-mail corresponder a uma conta, um link será enviado para redefinir sua senha.',
  'Import Data': 'Importar dados',
  'Import': 'Importar',
  'Inspection Due': 'Inspeção Vencida',
  'Inspection Report': 'Relatório de inspeção',
  'Inspection': 'Inspeção',
  'Inspections are up to date': 'As inspeções estão em dia',
  'January': 'Janeiro',
  'July': 'Julho',
  'June': 'Junho',
  'Leave': 'Sair',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'Lista de todos os equipamentos do local com opções de exibição de serviços e filtragem com base no devido atendimento e/ou inspeção.',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'Lista de todos os sites com suas informações. Opções para filtrar por status e mês de serviço para descobrir quais sites são atendidos em um mês específico.',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'Lista de equipamentos e deficiências do site, filtrada por equipamentos com deficiências que possuem data aberta e sem data fechada.',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'Lista de equipamentos entre datas variadas com respostas às dúvidas feitas na realização de um serviço ou inspeção.',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'Lista de equipamentos de um local com informações importantes, como data da última inspeção e próximo serviço, destacando em vermelho os equipamentos que devem ser inspecionados.',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'Lista de equipamentos que atendem aos critérios de pesquisa de modelo. Exemplo: uma lista de 5 equipamentos com informações de modelo correspondentes a 6LB ABC DRY.',
  'Loading Equipment': 'Equipamento de carregamento',
  'Loading Models...': 'Carregando modelos...',
  'Loading Scheduled Services...': 'Carregando serviços agendados...',
  'Loading Scheduled Sites': 'Carregando sites agendados',
  'Loading Service Types...': 'Carregando tipos de serviço...',
  'Loading Sites': 'Carregando sites',
  'Loading Unscheduled Services...': 'Carregando serviços não programados...',
  'Loading...': 'Carregando...',
  'Location': 'Localização',
  'Logging in...': 'Fazendo login...',
  'Login Failed': 'Falha no login',
  'Login': 'Entrar',
  'Logout': 'Sair',
  'March': 'Março',
  'May': 'Maio',
  'Meter Based Condition': 'Condição baseada no medidor',
  'Model Deleted': 'Modelo excluído',
  'Model Field Information': 'Informações do campo do modelo',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'Os campos do modelo permitem descrever e relatar equipamentos como "Tamanho", "Tipo" e "Categoria".',
  'Model Fields': 'Campos do modelo',
  'Model Information': 'Informações do modelo',
  'Model Name': 'Nome do modelo',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'Os modelos permitem adicionar rapidamente informações ao equipamento, como quais tipos de equipamentos/serviços pertencem a ele.',
  'Models': 'Modelos',
  'Months of History (to start of month)': 'Meses de história (até o início do mês)',
  'More Details': 'Mais detalhes',
  'Name': 'Nome',
  'Nevermind': 'Deixa pra lá',
  'No Custom Equipment Fields': 'Nenhum campo de equipamento personalizado',
  'No Deficiencies': 'Sem deficiências',
  'No Equipment Fields': 'Nenhum campo de equipamento',
  'No Equipment Types': 'Nenhum tipo de equipamento',
  'No Equipment': 'Nenhum equipamento',
  'No Floor Plans': 'Sem plantas baixas',
  'No History': 'Sem histórico',
  'No Model Fields': 'Nenhum campo de modelo',
  'No Models': 'Sem modelos',
  'No Open Deficiencies': 'Sem deficiências abertas',
  'No Open or Closed Issues': 'Sem problemas abertos ou fechados',
  'No overrides for this Site': 'Nenhuma substituição para este site',
  'No Questions': 'Sem perguntas',
  'No Scheduled Services': 'Nenhum serviço agendado',
  'No Scheduled Sites': 'Nenhum site agendado',
  'No Service Month Categories': 'Sem categorias de mês de serviço',
  'No Service Types': 'Nenhum tipo de serviço',
  'No Site Fields': 'Nenhum campo do site',
  'No Site Types': 'Nenhum tipo de site',
  'No Sites': 'Nenhum site',
  'No Unscheduled Services': 'Sem serviços não programados',
  'No, Go Back': 'Não, volte',
  'No': 'Não',
  'Not in at the time of inspection': 'Não estava no momento da inspeção',
  'Nothing to Inspect': 'Nada para inspecionar',
  'Nothing to Service': 'Nada para servir',
  'November': 'Novembro',
  'October': 'Outubro',
  'Ok': 'Ok',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'Abra uma deficiência clicando no sinal de adição no canto superior direito do painel. Quando o problema for resolvido, clique nele e defina a data de encerramento.',
  'Open a deficiency by tapping Options > Add Deficiency': 'Abra uma deficiência tocando em Opções > Adicionar Deficiência',
  'Open Deficiencies': 'Deficiências Abertas',
  'Open Deficiency': 'Deficiência Aberta',
  'Open in Apple Maps': 'Abrir no Apple Maps',
  'Open in Google Maps': 'Abrir no Google Maps',
  'Open Settings': 'Abra Configurações',
  'Open': 'Abrir',
  'Optional: Add a deficiency if this option is selected.': 'Opcional: Adicione uma deficiência se esta opção estiver selecionada.',
  'Optional: This can be useful to set meter values easily': 'Opcional: Isto pode ser útil para definir facilmente os valores do medidor',
  'Organization': 'Organização',
  'Outstanding Equipment': 'Equipamento excepcional',
  'PDF': 'PDF',
  'Perform From Now': 'Execute a partir de agora',
  'Perform From Scheduled': 'Executar a partir do programado',
  'Perform Service From Scheduled': 'Executar serviço a partir do agendado',
  'Perform Service': 'Executar serviço',
  'Perform': 'Executar',
  'Phone Number': 'Número de telefone',
  'Please fill out all fields': 'Por favor preencha todos os campos',
  'Please give a reason': 'Por favor, dê um motivo',
  'Please select country first': 'Selecione o país primeiro',
  'Popup Note': 'Nota pop-up',
  'Preferences': 'Preferências',
  'Preview Details': 'Detalhes de visualização',
  'Profile': 'Perfil',
  'Purchase Barcodes': 'Comprar códigos de barras',
  'Question Deleted': 'Pergunta excluída',
  'Question Information': 'Informações da pergunta',
  'Questionnaire Report': 'Relatório do questionário',
  'Questions': 'Perguntas',
  'Range End': 'Fim do intervalo',
  'Range Start': 'Início do intervalo',
  'Reactivate': 'Reativar',
  'Remove': 'Remover',
  'Replace Barcode': 'Substituir código de barras',
  'Replace Equipment': 'Substituir Equipamento',
  'Replaced equipment': 'Equipamento substituído',
  'Report Date': 'Data do relatório',
  'Reports': 'Relatórios',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'Economize tempo e minimize os riscos traçando a localização do equipamento em uma planta baixa deste local',
  'Save': 'Salvar',
  'Saving': 'Salvando',
  'Scan barcode to make changes': 'Digitalize o código de barras para fazer alterações',
  'Scan Barcode': 'Digitalizar código de barras',
  'Scan': 'Digitalizar',
  'Schedule': 'Cronograma',
  'Scheduled Event': 'Evento agendado',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'As definições de serviço agendado podem ser adicionadas ao tipo de equipamento em configurações > tipos de equipamento',
  'Scheduled': 'Agendado',
  'See More': 'Ver mais',
  'Selecting an option will add a history record and remove it from the todo list': 'Selecionar uma opção adicionará um registro de histórico e o removerá da lista de tarefas',
  'Selective Equipment Report': 'Relatório de Equipamento Seletivo',
  'September': 'Setembro',
  'Service Due': 'Serviço devido',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'As categorias de meses de serviço permitem manter diferentes tipos de equipamentos em meses diferentes. Por exemplo, você poderia inspecionar extintores de incêndio em agosto e maio e alarmes em outubro.',
  'Service Month Categories': 'Categorias do mês de serviço',
  'Service Month Category': 'Categoria Mês de Serviço',
  'Service Month': 'Mês de serviço',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'Os meses de serviço permitem manter diferentes tipos de equipamentos em meses selecionados para cada local. Exemplo: Alarmes em Maio e Outubro e Extintores em Dezembro.',
  'Service Months': 'Meses de serviço',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'As substituições de serviço permitem desativar um serviço ou alterar a frequência de um site específico',
  'Service Type Settings': 'Configurações de tipo de serviço',
  'Service Type': 'Tipo de serviço',
  'Service Types': 'Tipos de serviço',
  'Service': 'Serviço',
  'Services are up to date': 'Os serviços estão atualizados',
  'Services': 'Serviços',
  'Set answer to equipment field': 'Definir resposta para campo de equipamento',
  'Settings': 'Configurações',
  'Show Advanced': 'Mostrar avançado',
  'Show History Time': 'Mostrar hora do histórico',
  'Show Inspections': 'Mostrar inspeções',
  'Show Questions / Answers': 'Mostrar perguntas/respostas',
  'Show Services': 'Mostrar serviços',
  'Sign Up': 'Inscreva-se',
  'Simulate Scan': 'Simular digitalização',
  'Site Deleted': 'Site excluído',
  'Site Field Information': 'Informações do campo do site',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'Os campos do site permitirão que você insira informações adicionais no site, como "Local de estacionamento".',
  'Site Fields': 'Campos do site',
  'Site Information': 'Informações do local',
  'Site Report': 'Relatório do local',
  'Site Reports': 'Relatórios de sites',
  'Site Service Override': 'Substituição do serviço do site',
  'Site Service Overrides': 'Substituições de serviço do site',
  'Site Service Settings': 'Configurações de serviço do site',
  'Site Settings': 'Configurações do site',
  'Site Type': 'Tipo de site',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'Os tipos de site permitem alterar os tipos de serviço com base no site. Por exemplo, apenas clientes mensais apresentariam a inspeção mensal.',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'Os tipos de site permitem que você tenha diferentes tipos de serviços em diferentes tipos de sites. Por exemplo, você pode ter que fazer inspeções mensais em um local e apenas uma inspe��ão anual em outro.',
  'Site Types': 'Tipos de sites',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'Os sites podem ajudá-lo a organizar equipamentos em locais como “Escritório” ou “Armazém”. Se você administra uma empresa de serviços, pode adicionar seus clientes como sites. ',
  'Sites': 'Locais',
  'Start Date': 'Data de início',
  'Start Trial': 'Iniciar teste',
  'Status': 'Estado',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'Resumo dos serviços em um site separados por informações de modelo. Exemplo 5 Inspeções Mensais com informações do modelo 6LB DRY ABC.',
  'Swap Equipment': 'Trocar equipamento',
  'Swapped equipment': 'Equipamento trocado',
  'TEST': 'TESTE',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'O plano EMS é um plano com desconto para serviços de saúde sem fins lucrativos ou com financiamento público.  Escolha outro plano se você não atender a esses critérios',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'A nota pop-up é usada para lembrá-lo de informações importantes sobre o local. Ele aparecerá ao abrir a tela de localização.',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'Não existem locais não programados com inspeções, serviços ou deficiências pendentes.',
  'There is no equipment at this site with this search criteria and due inspections': 'Não há equipamentos neste local com este critério de busca e devidas inspeções',
  'There is no equipment at this site with this search criteria and due service': 'Não existe nenhum equipamento neste site com este critério de pesquisa e devido atendimento',
  'This Month': 'Este mês',
  'Time at Site Detailed': 'Tempo no local detalhado',
  'Time at Site': 'Tempo no local',
  'Time Based Condition': 'Condição Baseada no Tempo',
  'Today': 'Hoje',
  'Transfer Equipment': 'Equipamento de transferência',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'Definições de serviços não programados podem ser adicionadas ao tipo de equipamento em configurações > tipos de equipamento',
  'Unscheduled': 'Não programado',
  'Updated barcode': 'Código de barras atualizado',
  'Used Equipment SKU': 'SKU de equipamento usado',
  'Used for the billing export for new, swapped and replaced equipment.': 'Utilizado para exportação de faturamento de equipamentos novos, permutados e substituídos.',
  'User Deleted': 'Usuário excluído',
  'User Information': 'Informações do usuário',
  'User': 'Usuário',
  'Users': 'Usuários',
  'View on FloorPlan': 'Ver na planta baixa',
  'View Terms': 'Ver Termos',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'Sempre que o equipamento for trocado o faturamento da exportação aumentará a quantidade deste SKU.',
  'Yes, Delete Equipment Field': 'Sim, excluir campo de equipamento',
  'Yes, Delete Equipment Type': 'Sim, excluir tipo de equipamento',
  'Yes, Delete Equipment': 'Sim, excluir equipamento',
  'Yes, Delete Floor Plan': 'Sim, excluir planta baixa',
  'Yes, Delete Model Field': 'Sim, excluir campo do modelo',
  'Yes, Delete Model': 'Sim, excluir modelo',
  'Yes, Delete Question': 'Sim, excluir pergunta',
  'Yes, Delete Record': 'Sim, excluir registro',
  'Yes, Delete Service Month': 'Sim, excluir mês de serviço',
  'Yes, Delete Service Type': 'Sim, excluir tipo de serviço',
  'Yes, Delete Site Field': 'Sim, excluir campo do site',
  'Yes, Delete Site Type': 'Sim, excluir tipo de site',
  'Yes, Delete Site': 'Sim, excluir site',
  'Yes, Delete User': 'Sim, excluir usuário',
  'Zone': 'Zona',
  'Customer': 'Cliente',
  'Site': 'Local',
  'All Sites': 'Todos os sites',
  'Loading Customers': 'Carregando Clientes',
  'No Customers': 'Nenhum cliente',
  'Add Customer': 'Adicionar cliente',
  'Customers are groups of sites with billing information.': 'Os clientes são grupos de sites com informações de cobrança.',
  'Customers': 'Clientes',
  'Customer Information': 'Informações do cliente',
  'Delete Customer': 'Excluir cliente',
  'Yes, Delete Customer': 'Sim, excluir cliente',
  'Delete Customer?': 'Excluir cliente?',
  'Customer Deleted': 'Cliente excluído',
  'Create Customer': 'Criar cliente',
  'Assign Existing Customer': 'Atribuir cliente existente',
  'Edit Customer': 'Editar cliente',
  'Enter a serial number': 'Insira um número de série',
  'Remove Customer': 'Remover cliente',
  'Find': 'Encontrar',
  'Sync Now': 'Sincronizar agora',
  'Syncing...': 'Sincronizando...',
  'Find equipment by serial number': 'Encontre equipamentos por número de série',
  'Last successful upload was {formattedDate}': 'O último upload bem-sucedido foi {formattedDate}',
  'Up to date as of {formattedDate}': 'Atualizado em {formattedDate}',
  'Zones are used to group locations in the location report': 'As zonas são usadas para agrupar locais no relatório de localização',

  'Account Number': 'Número de conta',
  'Add Location Override': 'Adicionar substituição de local',
  'Add New Model': 'Adicionar novo modelo',
  'Add Site Field': 'Adicionar campo de site',
  'Address Line 2': 'Linha de endereço 2',
  'Agree to': 'Concordo em',
  'All conditions are true': 'Todas as condições são verdadeiras',
  'All Permissions': 'Todas as permissões',
  'Allow Text Input': 'Permitir entrada de texto',
  'An email with the reset password link below has been sent to': 'Um e-mail com o link de redefinição de senha abaixo foi enviado para',
  'An error ocurred while trying to show this page.': 'Ocorreu um erro ao tentar mostrar esta página.',
  'Any condition is true': 'Qualquer condição é verdadeira',
  'Background Color': 'Cor de fundo',
  'Billing and customer controls': 'Faturamento e controles de clientes',
  'Building Reports - Safety Scan': 'Relatórios de construção - Verificação de segurança',
  'Change Another Service': 'Alterar outro serviço',
  'Choose Site': 'Escolha o site',
  'click here': 'Clique aqui',
  'Closed Date': 'Data de fechamento',
  'Closed Deficiencies': 'Deficiências Fechadas',
  'Company Information': 'Informações da empresa',
  'Company Name': 'nome da empresa',
  'Completing Sign Up': 'Concluindo a inscrição',
  'Context ID': 'ID do contexto',
  'Could not find equipment with that barcode': 'Não foi possível encontrar equipamento com esse código de barras',
  'Creating invite link...': 'Criando link de convite...',
  'Current equipment failed to load': 'O equipamento atual não foi carregado',
  'Data File': 'Arquivo de dados',
  'Data Origin': 'Origem dos dados',
  'Date affected by': 'Data afetada por',
  'Date Completed': 'Data de conclusão',
  'Date Started': 'Data de início',
  'Delete equipment?': 'Excluir equipamento?',
  'Dev Environment': 'Ambiente de desenvolvimento',
  'Disabled For': 'Desativado para',
  'Disabled For Location': 'Desativado para localização',
  'Do not change': 'Não mude',
  'Due When': 'Vencimento quando',
  'Edit Deficiencies': 'Editar deficiências',
  'Edit History': 'Editar histórico',
  'Edit Location': 'Editar local',
  'Edit Schedule': 'Editar agendamento',
  'Edit Service': 'Editar serviço',
  'Edit Settings': 'Editar configurações',
  'End Time': 'Hora de término',
  'Equal to': 'Igual a',
  'Equipment Field': 'Campo de Equipamentos',
  'Equipment replaced': 'Equipamento substituído',
  'Equipment swapped': 'Equipamento trocado',
  'Example: Broken Handle': 'Exemplo: alça quebrada',
  'Frequency Type': 'Tipo de frequência',
  'Generate Reports': 'Gerar relatórios',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'Comece conferindo nossos tutoriais no YouTube ou configurando sua conta nas configurações.',
  'Global Search': 'Pesquisa global',
  'Greater than': 'Maior que',
  'hasn&apos;t accepted their invite yet. You can': 'ainda não aceitou o convite. ',
  'Include In Reports': 'Incluir em relatórios',
  'landscape LetterHead': 'papel timbrado paisagem',
  'Last Date': 'Última data',
  'Last Date Minimum Granularity': 'Granularidade mínima da última data',
  'Last Download': 'Último download',
  'Last Upload': 'Último upload',
  'Less than': 'Menor que',
  'Locations can only be added on a desktop browser': 'Os locais só podem ser adicionados em um navegador de desktop',
  'Looks like you never finished signing up': 'Parece que você nunca terminou de se inscrever',
  'Metered Condition': 'Condição medida',
  'Mobile Access': 'Acesso móvel',
  'Model Number': 'Número do modelo',
  'Next Date (Overide)': 'Próxima data (substituir)',
  'No Conditions': 'Sem condições',
  'No Options': 'Sem opções',
  'Not equal to': 'Não é igual a',
  'Opened Date': 'Data de abertura',
  'Option Selected': 'Opção selecionada',
  'Perform On Scan': 'Executar na varredura',
  'Please click the button below to start your free 3 month trial': 'Clique no botão abaixo para iniciar seu teste gratuito de 3 meses',
  'Please review the terms below': 'Revise os termos abaixo',
  'Portrait LetterHead': 'Cabeçalho Retrato',
  'Postal Code': 'Código postal',
  'Powered By': 'Distribuído por',
  'Preventive Maintenance': 'Manutenção preventiva',
  'Profile Image': 'Imagem do perfil',
  'Receive marketing emails': 'Receba e-mails de marketing',
  'Rivison Inc.': 'Rivison Inc.',
  'Search Sites...': 'Pesquisar sites...',
  'Serial Number': 'Número de série',
  'Service is Unscheduled': 'O serviço não está programado',
  'Service Options': 'Opções de serviço',
  'Service or Inspection Due': 'Serviço ou inspeção devido',
  'Show All': 'Mostrar tudo',
  'Show site selector in top corner': 'Mostrar seletor de sites no canto superior',
  'Sign-Up Failed. Ensure the email is not already is use.': 'Falha na inscrição. ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'Desculpe, ocorreu um erro ao tentar criar um link de convite. ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'Desculpe, parece que você está off-line. ',
  'Start Time': 'Hora de início',
  'Successfully updated profile': 'Perfil atualizado com sucesso',
  'terms and conditions': 'termos e Condições',
  'Text Input': 'Entrada de texto',
  'The date below is used to show history records only.': 'A data abaixo é usada apenas para mostrar registros históricos.',
  'This will just take a moment': 'Isso só levará um momento',
  'Time Condition': 'Condição de tempo',
  'Time Zone': 'Fuso horário',
  'to generate another invite link.': 'para gerar outro link de convite.',
  'Toggle Flashlight': 'Alternar lanterna',
  'Type more characters to narrow the search further': 'Digite mais caracteres para restringir ainda mais a pesquisa',
  'Use text answer for': 'Use resposta de texto para',
  'Version:': 'Versão:',
  'View Deficiencies': 'Ver deficiências',
  'View Equipment': 'Ver Equipamento',
  'View History': 'Ver histórico',
  'View Location': 'Ver localização',
  'View Schedule': 'Ver programação',
  'View Service': 'Ver serviço',
  'View Settings': 'Ver configurações',
  'We hope to see you again.': 'Esperamos vê-lo novamente.',
  'Web Login': 'Login na Web',
  'Welcome,': 'Bem-vindo,',
  'White Label': 'Etiqueta Branca',
  'Work Day End Time': 'Horário de término do dia útil',
  'Work Day Start Time': 'Hora de início do dia útil',
  'You must agree to the terms and conditions': 'Você deve concordar com os termos e condições',
  'Your Subscription Has Been Canceled': 'Sua assinatura foi cancelada',
};
